import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=7ba98881&"
import script from "./form-item.vue?vue&type=script&lang=js&"
export * from "./form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba98881')) {
      api.createRecord('7ba98881', component.options)
    } else {
      api.reload('7ba98881', component.options)
    }
    module.hot.accept("./form-item.vue?vue&type=template&id=7ba98881&", function () {
      api.rerender('7ba98881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/form-item.vue"
export default component.exports